/* eslint-disable */
import { FuseNavigationItem } from '@fuse/components/navigation';

export const defaultNavigation: FuseNavigationItem[] = [{
    id: 'org-dashboards',
    title: 'Main',
    subtitle: 'Dashboards and proposals',
    type: 'group',
    icon: 'heroicons_outline:home',
    children: [
        {
            id   : 'dashboard',
            title: 'Dashboard',
            type : 'basic',
            icon : 'heroicons_outline:chart-pie',
            link : '/dashboard',
            access: ['ADMIN', 'MEMBER']
        },    
        {
            id   : 'proposals',
            title: 'Proposals',
            type : 'basic',
            icon : 'heroicons_outline:clipboard-document-check',
            link : '/proposals',
            access: ['ADMIN', 'MEMBER']
        }
    ]
}, {
    id: 'org-settings',
    title: 'Organisation Settings',
    subtitle: 'Company and proposal settings',
    type: 'group',
    icon: 'heroicons_outline:cog-6-tooth',
    access: ['ADMIN'],
    children: [
        {
            id   : 'org-account',
            title: 'Account',
            type : 'basic',
            icon : 'heroicons_outline:building-office',
            link : '/settings/account',
            access: ['ADMIN']
        },
        {
            id   : 'org-team',
            title: 'Team',
            type : 'basic',
            icon : 'heroicons_outline:users',
            link : '/settings/team',
            access: ['ADMIN']
        },
        {
            id: 'org-proposal-settings',
            title: 'Proposal Settings',
            type : 'basic',
            icon : 'heroicons_outline:document-text',
            link : '/settings/proposal-settings',
            access: ['ADMIN']
        },
        {
            id: 'org-pricing',
            title: 'Billing',
            type : 'basic',
            icon : 'heroicons_outline:document-text',
            link : '/settings/pricing',
            access: ['ADMIN']
        }
    ]
}, {
    id: 'user-settings',
    title: 'User Settings',
    subtitle: 'User settings and preferences',
    type: 'group',
    icon: 'heroicons_outline:user-circle',
    children: [
        {
            id   : 'user-account',
            title: 'Account',
            type : 'basic',
            icon : 'heroicons_outline:user-circle',
            link : '/user/settings/profile',
            access: ['ADMIN', 'MEMBER']
        },
        {
            id   : 'user-preferences',
            title: 'Preferences',
            type : 'basic',
            icon : 'heroicons_outline:cog-6-tooth',
            link : '/user/settings/preferences',
            access: ['ADMIN', 'MEMBER']
        },
        {
            id   : 'user-reset-password',
            title: 'Reset Password',
            type : 'basic',
            icon : 'heroicons_outline:key',
            link : '/user/settings/password',
            access: ['ADMIN', 'MEMBER']
        }
    ]
}
];
export const compactNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const futuristicNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
export const horizontalNavigation: FuseNavigationItem[] = [
    {
        id   : 'example',
        title: 'Example',
        type : 'basic',
        icon : 'heroicons_outline:chart-pie',
        link : '/example'
    }
];
